import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useOrderAlerts } from '../../contexts/OrderAlertsContext';
import { accountPath } from '../../utils/accountPath';

const OrderAlertStack = ({ accountId }) => {
  const navigate = useNavigate();
  const { alerts, dismissAlert } = useOrderAlerts();

  const visible = alerts.filter((a) => a.visible);

  if (!visible.length) return null;

  return (
    <div className="order-alert-stack" aria-live="polite">
      {visible.map((alert) => {
        const isStale = alert.type === 'staleOrder' || alert.type === 'printOffline';

        return (
          <div
            key={alert.id}
            className={`order-alert-toast ${isStale ? 'order-alert-toast--stale' : 'order-alert-toast--new'}`}
          >
            <div className="order-alert-toast__icon">
              <i className={`tim-icons ${isStale ? 'icon-time-alarm' : 'icon-bell-55'}`} />
            </div>
            <div className="order-alert-toast__body">
              <p className="order-alert-toast__message">{alert.message}</p>
              <div className="order-alert-toast__actions">
                <button
                  type="button"
                  className="order-alert-toast__btn order-alert-toast__btn--primary"
                  onClick={() => {
                    dismissAlert(alert.id);
                    navigate(
                      accountPath(
                        accountId,
                        alert.type === 'printOffline' ? '/configuracoes/impressao' : '/pedidos',
                      ),
                    );
                  }}
                >
                  Ver
                </button>
                <button
                  type="button"
                  className="order-alert-toast__btn order-alert-toast__btn--ghost"
                  onClick={() => dismissAlert(alert.id)}
                >
                  Fechar
                </button>
              </div>
            </div>
            <button
              type="button"
              className="order-alert-toast__close"
              aria-label="Fechar"
              onClick={() => dismissAlert(alert.id)}
            >
              <i className="tim-icons icon-simple-remove" />
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default OrderAlertStack;
